import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'
export default class Flyer_layout_bottom_middle_aligned_011LayoutModel extends FlyerLayoutAbstract {
  flourishes = []

  textLayouts = {
    event_name_1: {
      top: 413,
      left: 10,
      size: 20,
      width: 300,
      height: 23.5,
      lineHeight: 23.5,
      align: 'center',
      widthAlign: 'center',
      whiteSpace: 'pre'
    },
    location_1: {
      top: 384,
      size: 18,
      left: 10,
      width: 300,
      height: 21,
      align: 'center'
    },
    location_2: {
      top: 448.5,
      size: 26,
      left: 10,
      width: 300,
      height: 30.5,
      lineHeight: 30.5,
      align: 'center',
      widthAlign: 'center',
      whiteSpace: 'pre'
    }
  }

  dateLayouts = {
    date_1: {
      top: 339,
      daySize: 30,
      left: 10,
      width: 300,
      height: 35
    },
    date_2: {
      daySize: 18,
      top: 489,
      left: 10,
      width: 300,
      height: 21
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText2() {
    if (this.getDefaultText2()) {
      return `~${this.getDefaultText2()}~`
    }

    if (this.getDefaultText3()) {
      return `~${this.getDefaultText3()}~`
    }

    return null
  }

  getDayOfWeek(date, timeZone, allCaps) {
    if (allCaps) {
      return date ? moment.tz(date, timeZone).format('ddd').toUpperCase() : ''
    }
    return date ? moment.tz(date, timeZone).format('ddd') : ''
  }
  formatTime(date, timeZone, allCaps) {
    if (allCaps) {
      return date ? moment.tz(date, timeZone).format('h:mma').toUpperCase() : ''
    }
    return date ? moment.tz(date, timeZone).format('h:mma') : ''
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const date1 = this.dateLayouts.date_1
    const date2 = this.dateLayouts.date_2

    const date1Props = this.dateProps.date1Props
    const date2Props = this.dateProps.date2Props

    const { formattedStart, formattedEnd, isSameDay } = this.formatDates({
      day: 'MM-DD-YY',
      time: 'h:mma'
    })

    const startDayOfWeek = this.getDayOfWeek(startDate, timeZone, date1Props.all_caps)
    const endDayOfWeek = endDate ? this.getDayOfWeek(endDate, timeZone, date1Props.all_caps) : ''

    let topDateLabel = ''
    let bottomDateLabel = ''

    if (!startDate) {
      return { type: 'date', dates: [] }
    }

    if (!endDate) {
      topDateLabel = `•${startDayOfWeek}•`
      bottomDateLabel = `${formattedStart} | ${this.formatTime(startDate, timeZone, date2Props.all_caps)}`
    } else if (isSameDay) {
      topDateLabel = `•${startDayOfWeek}•`
      bottomDateLabel = `${formattedStart} | ${this.formatTime(startDate, timeZone, date2Props.all_caps)}-${this.formatTime(endDate, timeZone, date2Props.all_caps)}`
    } else {
      topDateLabel = `•${startDayOfWeek}-${endDayOfWeek}•`
      bottomDateLabel = `${formattedStart} ${this.formatTime(startDate, timeZone, date2Props.all_caps)} | ${formattedEnd} ${this.formatTime(endDate, timeZone, date2Props.all_caps)}`
    }

    return {
      type: 'date',
      dates: [
        {
          text: topDateLabel,
          align: date1.align || 'center',
          width: date1.width,
          top: date1.top,
          height: date1.height,
          left: date1.left,
          color: date1Props?.color?.replace('0x', '#') || '#000',
          font: date1Props?.font?.replace(/\s+/g, '-') || 'Arial',
          size: date1.daySize
        },
        {
          text: bottomDateLabel,
          align: date2.align || 'center',
          width: date2.width,
          top: date2.top,
          height: date2.height,
          left: date2.left,
          color: date2Props?.color?.replace('0x', '#') || '#000',
          font: date2Props?.font?.replace(/\s+/g, '-') || 'Arial',
          size: date2.daySize
        }
      ]
    }
  }
}
